import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FixMeLater, QRCodeElementType } from 'angularx-qrcode';
import { HttpService } from 'src/app/services/http-service.service';
import { AlertsService } from 'src/app/services/alerts.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-reservacion-complete',
  templateUrl: './reservacion-complete.component.html',
  styleUrls: ['./reservacion-complete.component.scss'],
})
export class ReservacionCompleteComponent {
  @Input() reservacion: any;
  public isEditing = false;
  public cotizacion: any;
  public elementType: QRCodeElementType = 'canvas';

  constructor(
    private activeRoute: ActivatedRoute,
    private readonly location: Location,
    private readonly _httpService: HttpService,
    private readonly _alertService: AlertsService,
    private readonly _translate: TranslateService,
  ) {
    this.reservacion = JSON.parse(
      sessionStorage.getItem('reservations') || '{}'
    ).find(
      (reservation: any) =>
        reservation.id == this.activeRoute.snapshot.params['id']
    );
  }

  ngOnInit(): void {
    this.cotizacion = {
      from: this.reservacion.transaction[0].idCurrencyPayment,
      to: this.reservacion.transaction[0].idCurrencyReceives,
      in: this.reservacion.transaction[0].amountPayment,
      out: this.reservacion.transaction[0].amountReceives,
    };
  }

  print() {
    window.print();
  }

  atras() {
    this.location.back();
  }

  saveAsImage(parent: FixMeLater) {
    let parentElement = null;

    if (this.elementType === 'canvas') {
      // fetches base 64 data from canvas
      parentElement = parent.qrcElement.nativeElement
        .querySelector('canvas')
        .toDataURL('image/png');
    } else if (this.elementType === 'img' || this.elementType === 'url') {
      // fetches base 64 data from image
      // parentElement contains the base64 encoded image src
      // you might use to store somewhere
      parentElement = parent.qrcElement.nativeElement.querySelector('img').src;
    } else {
      alert("Set elementType to 'canvas', 'img' or 'url'.");
    }

    if (parentElement) {
      // converts base 64 encoded image to blobData
      let blobData = this.convertBase64ToBlob(parentElement);
      // saves as image
      const blob = new Blob([blobData], { type: 'image/png' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      // name of the file
      link.download = this.reservacion.order;
      link.click();
    }
  }

  private convertBase64ToBlob(Base64Image: string) {
    // split into two parts
    const parts = Base64Image.split(';base64,');
    // hold the content type
    const imageType = parts[0].split(':')[1];
    // decode base64 string
    const decodedData = window.atob(parts[1]);
    // create unit8array of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length);
    // insert all character code into uint8array
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // return blob image after conversion
    return new Blob([uInt8Array], { type: imageType });
  }

  cancelarReservacion() {
    this._alertService
      .showConfirm({
        title: this._translate.instant(
          'RESERVATIONS_DETAILS.CONFIRM_CANCEL_TITLE',
        ),
        text: this._translate.instant(
          'RESERVATIONS_DETAILS.CONFIRM_CANCEL_TEXT',
        ),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this._translate.instant(
          'RESERVATIONS_DETAILS.CONFIRM_YES_CANCEL',
        ),
        cancelButtonText: this._translate.instant(
          'RESERVATIONS_DETAILS.CONFIRM_NO_KEEP',
        ),
      })
      .then((result) => {
        if (result.isConfirmed) {
          this._httpService
            .cancelarReservacion(this.reservacion.id)
            .subscribe(() => {
              this._alertService.show({
                title: this._translate.instant(
                  'RESERVATIONS_DETAILS.SUCCESS_CANCEL_TITLE',
                ),
                text: this._translate.instant(
                  'RESERVATIONS_DETAILS.SUCCESS_CANCEL_TEXT',
                ),
                icon: 'success',
                confirmButtonText: this._translate.instant(
                  'RESERVATIONS_DETAILS.BUTTON_ACCEPT',
                ),
              });
              this.location.back();
            });
        }
      });
  }
}
